<template>
  <div>
    <Themes></Themes>
  </div>
</template>
<script>
import Themes from './components/themes.vue'
export default {
  components: {
    Themes
  }
}
</script>
